<template>
  <div class="w1200 zhaogu-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">我的实战超市销售总览</div>

    <el-table v-loading="loading" :data="list" empty-text="暂无发布的方案"
      :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="title" label="实战方案" show-overflow-tooltip></el-table-column>
      <el-table-column label="彩种" width="100">
        <template slot-scope="{ row }">{{ row.preTypeIntro || lotteryTypeName(row.preType) }}</template>
      </el-table-column>
      <el-table-column prop="preNumber" label="期数" width="110"></el-table-column>
      <el-table-column label="缩币价格" width="110">
        <template slot-scope="{ row }">{{ money(row.coin) }} 缩币</template>
      </el-table-column>
      <el-table-column label="上架状态" width="100">
        <template slot-scope="{ row }">
          <el-tag :type="row.status == '1' ? 'success' : 'info'" size="small">
            {{ row.status == '1' ? '上架中' : '已下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="buyerCount" label="购买人数" width="100"></el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openBuyers(row)">查看买家明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 买家明细 -->
    <el-dialog title="买家明细" :visible.sync="buyersDialog" width="720px" @close="buyersList = []">
      <div v-loading="buyersLoading" style="min-height: 120px;">
        <el-table :data="buyersList" empty-text="暂无买家" v-if="buyersList.length"
          :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
          <el-table-column prop="nickName" label="昵称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="userName" label="账号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="phonenumber" label="手机号" width="140"></el-table-column>
          <el-table-column label="购买状态" width="100">
            <template slot-scope="{ row }">
              <el-tag :type="row.status == 1 ? 'success' : (row.status == 2 ? 'warning' : 'info')" size="small">
                {{ row.status == 1 ? '已支付' : (row.status == 2 ? '已退款' : '待支付') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="purchaseTime" label="购买时间" width="170"></el-table-column>
        </el-table>
        <div v-else class="tip-msg">暂无买家</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMySoldMarkets } from "@/api/personalCenter";

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

export default {
  name: "MarketMySold",
  data() {
    return {
      list: [],
      loading: false,
      buyersDialog: false,
      buyersLoading: false,
      buyersList: [],
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    goBack() {
      this.$router.push("/sttzzbfzx/chaoshi");
    },
    lotteryTypeName(type) {
      return LOTTERY_MAP[type] || type || "-";
    },
    money(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return isNaN(n) ? v : n;
    },
    // 销售总览：GET /stage-api/assist/market/my/sold（返回 Result<List<AssistMarketSoldVO>>，每项含 buyers）
    loadList() {
      this.loading = true;
      getMySoldMarkets()
        .then((res) => {
          const data = res && res.data !== undefined ? res.data : res;
          this.list = Array.isArray(data) ? data : (data && data.rows) || [];
        })
        .catch(() => {
          this.list = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 买家明细直接来自销售总览 VO.buyers，无需再次请求
    openBuyers(row) {
      this.buyersDialog = true;
      this.buyersLoading = true;
      this.buyersList = (row && row.buyers) || [];
      this.buyersLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }
}

.tip-msg {
  color: #898af7;
  font-weight: bold;
  padding: 14px 0;
  text-align: center;
}
</style>
